/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ReferencedWorkDTO } from './ReferencedWorkDTO';
import {
    ReferencedWorkDTOFromJSON,
    ReferencedWorkDTOFromJSONTyped,
    ReferencedWorkDTOToJSON,
    ReferencedWorkDTOToJSONTyped,
} from './ReferencedWorkDTO';

/**
 * 
 * @export
 * @interface WorkIsPartOfDTO
 */
export interface WorkIsPartOfDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkIsPartOfDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkIsPartOfDTO
     */
    articleId?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkIsPartOfDTO
     */
    issue?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkIsPartOfDTO
     */
    pageFirst?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkIsPartOfDTO
     */
    pageLast?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkIsPartOfDTO
     */
    volume?: string;
    /**
     * 
     * @type {ReferencedWorkDTO}
     * @memberof WorkIsPartOfDTO
     */
    referencedWork?: ReferencedWorkDTO;
}

/**
 * Check if a given object implements the WorkIsPartOfDTO interface.
 */
export function instanceOfWorkIsPartOfDTO(value: object): value is WorkIsPartOfDTO {
    return true;
}

export function WorkIsPartOfDTOFromJSON(json: any): WorkIsPartOfDTO {
    return WorkIsPartOfDTOFromJSONTyped(json, false);
}

export function WorkIsPartOfDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkIsPartOfDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'articleId': json['articleId'] == null ? undefined : json['articleId'],
                  'issue': json['issue'] == null ? undefined : json['issue'],
                  'pageFirst': json['pageFirst'] == null ? undefined : json['pageFirst'],
                  'pageLast': json['pageLast'] == null ? undefined : json['pageLast'],
                  'volume': json['volume'] == null ? undefined : json['volume'],
                  'referencedWork': json['referencedWork'] == null ? undefined : ReferencedWorkDTOFromJSON(json['referencedWork']),
    };
}

export function WorkIsPartOfDTOToJSON(json: any): WorkIsPartOfDTO {
    return WorkIsPartOfDTOToJSONTyped(json, false);
}

export function WorkIsPartOfDTOToJSONTyped(value?: WorkIsPartOfDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'articleId': value['articleId'],
        'issue': value['issue'],
        'pageFirst': value['pageFirst'],
        'pageLast': value['pageLast'],
        'volume': value['volume'],
        'referencedWork': ReferencedWorkDTOToJSON(value['referencedWork']),
    };
}


